#import '../queries/AliyahDetailsWithParashah.graphql'
mutation CreateOrUpdateAliyah(
  $year: Int
  $parashah: ID!
  $rank: Int!
  $section: String!
  $variant: String!
  $id: ID
  $comment: String
  $username: String
) {
  createAliyah(
    year: $year
    parashah: $parashah
    rank: $rank
    section: $section
    variant: $variant
    id: $id
    comment: $comment
    username: $username
  ) {
    ok
    errors
    aliyah {
      ...aliyahDetailsWithParashah
    }
  }
}
